'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GQL_UPDATE_HEARTBEAT = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    mutation heartbeat {\n        heartbeat {\n            duration\n        }\n    }\n'], ['\n    mutation heartbeat {\n        heartbeat {\n            duration\n        }\n    }\n']);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GQL_UPDATE_HEARTBEAT = exports.GQL_UPDATE_HEARTBEAT = (0, _graphqlTag2.default)(_templateObject);